import React, { useState, useEffect, useContext } from "react";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
// import { RegxExpression } from "../../../../utils/common";
import Select from "react-select";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Errors } from "../../../../../utils/errors";
import { RegxExpression, Select2Data } from "../../../../../utils/common";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ReactPasswordChecklist from "react-password-checklist";
import { City, Country, Pincode, State } from "../../../../../utils/apis/master/Master";
import { checkUser } from "../../../../../utils/apis/common/Common";

const Stepone = ({ prevStep, nextStep, setStepData, savedData }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [passwordAgain, setPasswordAgain] = useState("");
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);


  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    setValue,
    trigger,
  } = useForm({
    defaultValues: savedData || {}, // Initialize with saved data if available
  });

  console.log("errors",errors)




  useEffect(() => {
    // Reset form with saved data when component loads
    if (savedData) {
      reset(savedData);
    }
  }, [savedData, reset]);

  console.log("errors",errors)


  const onSubmit = async (d) => {
    const data = getValues();
    console.log("onSubmit", data);

    if (Object.keys(errors).length > 0) {
      console.log("There are errors, cannot proceed to next step");
      return;

    } else if (data?.password !== data?.re_password) {
      
      console.log("ersdfsdfsdfsdfsdfsdfsdfsdfsdfdfrors")
      setError("re_password", {
        type: "manual",
        message: "Passwords do not match",
      });

    } else {
    
      setStepData(data);
      nextStep();
    }


  };



  const getCountry = async () => {
    const res = await Country()
    if (res?.success) {
      const data = await Select2Data(res?.data, "country_id", false)
      setCountryOptions(data)
    }
  }

  const getStates = async (country_id) => {
    const res = await State(country_id)
    if (res?.success) {
      const data = await Select2Data(res.data, "state_id", false);
      setStateOptions(data);
      setValue("state_id", "");
      setValue("city_id", "");
      setValue("pincode_id", "");
    }
  }

  const getCites = async (state_id) => {
    const res = await City(state_id);
    if (res?.success) {
      const data = await Select2Data(res.data, "city_id", false);
      setCityOptions(data);
      setValue("city_id", "");
      setValue("pincode_id", "");
    }
  };

  const getPincodes = async (id) => {
    const res = await Pincode(id);
    if (res?.success) {
      const data = await Select2Data(res.data, "pincode_id", false);
      setPincodeOptions(data);
      setValue("pincode_id", "");
    }
  };


  console.log("stateOptions", stateOptions)


  useEffect(() => {
    getCountry()
  }, [])



  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    }

    if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const options = [
    { value: "Nashik", label: "Chocolate" },
    { value: "Pune", label: "Strawberry" },
    { value: "Mumbai", label: "Vanilla" },
  ];

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);





  const [mobileVerify, setMobileVerify] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null);

  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [userExistError, setuserExistError] = useState("");

  // Check API only when both values are present

  console.log("errors", errors)

  const checkIfUserExists = async () => {

    if (email && contactNo) {
      try {
        const res = await checkUser({ email, contact_no: contactNo });
        console.log("API Response:", res);

        if (res?.message?.email && res?.message?.contact_no) {
          clearErrors(["email", "contact_no"]);
        }

        if (!res?.success) {


          if (res?.message?.email) {
            setError("email", { type: "server", message: res?.message.email });
          } else {
            clearErrors(["email"]);
          }

          if (res?.message?.contact_no) {
            setError("contact_no", { type: "server", message: res?.message.contact_no });
          } else {
            clearErrors(["contact_no"]);
          }
        } else {
          clearErrors(["email", "contact_no"]);
        }

      } catch (error) {
        console.error("Error checking user existence:", error);
      }
    }
  };


  useEffect(() => {
    checkIfUserExists();
  }, [contactNo, email])

  // Debounce API check
  // const debouncedCheck = debounce(() => {
  //   checkIfUserExists();
  // }, 500);

  // Handle email change
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value); // Update email state
    // Trigger debounced check
  };

  // Handle contact number change
  const handleContactChange = (value) => {
    setContactNo(value); // Trigger debounced check
  };

  return (
    <>
      <div className="personal-details-form ">
        {/* form-holder */}

        <div className="details-form-holder">
          <div className="form-container">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="">
                <div className="row ">
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">First Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name=""
                        placeholder="Enter First Name"

                        {...register("first_name", {
                          required: Errors.first_name,
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.first_name,
                          "is-valid": getValues("first_name"),
                        })}
                        onKeyDown={(event) => {
                          if (!RegxExpression.name.test(event.key)) {
                            event.preventDefault();
                          }
                        }}

                      />
                      {errors.first_name && (
                        <span className="text-danger">
                          {errors.first_name?.message}
                        </span>
                      )}
                      {/* <Select
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options}
                        classNamePrefix="buisness"
                      /> */}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">Last Name*</Form.Label>

                        <Form.Control
                          type="text"
                          name=""
                          placeholder="Enter Last Name*"
                          {...register("last_name", {
                            required: Errors.last_name,
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.last_name,
                            "is-valid": getValues("last_name"),
                          })}
                          onKeyDown={(event) => {
                            if (!RegxExpression.name.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        {errors.last_name && (
                          <span className="text-danger">
                            {errors.last_name?.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>

              {/*   Mobile Number , Date of Birth,  Gender*/}
              <div className="">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-field">
                      <Form.Group controlId="email">
                        <Form.Label className="required">
                          Email*
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="email"
                          placeholder="Enter Email"
                          {...register("email", {
                            required: Errors.email,
                            pattern: {
                              value: RegxExpression.email,
                              message: Errors.email_invalid,
                            },
                            onChange: handleEmailChange, // Use onChange here
                          })}
                          inputProps={{
                            autoComplete: "off", // Prevent browser autofill
                          }}
                          className={classNames("", {
                            "is-invalid": errors?.email,
                            "is-valid": getValues("email"),
                          })}
                        />
                        {errors.email && (
                          <span className="text-danger">
                            {errors.email?.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required form-field">
                          Address*
                        </Form.Label>

                        <div className="get-otp-text">
                          <Form.Control
                            type="text"
                            name=""
                            placeholder="Enter Address"
                            {...register("address", {
                              required: Errors.address,
                            })}
                            className={classNames("", {
                              "is-valid": getValues("address"),
                            })}
                          />
                        </div>
                        {errors.address && (
                          <span className="text-danger">
                            {errors.address?.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <Form className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">
                          Mobile Number*
                        </Form.Label>

                        <Controller
                          name="contact_no"
                          control={control}
                          render={({ field }) => (
                            <div style={{ position: "relative" }}>
                              <PhoneInput
                                country="in"
                                name="contact_no"
                                value={field.value}
                                onChange={(value) => {
                                  field.onChange(value)
                                  handleContactChange(value)
                                }}
                                inputStyle={{
                                  borderColor: errors.contact_no
                                    ? "red"
                                    : mobileVerify
                                      ? "green"
                                      : "",
                                }}
                                disabled={mobileVerify}
                              />
                              {mobileVerify && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "green",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    ✔
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                          rules={{ required: Errors.phone }}
                        />
                        {errors.contact_no && (
                          <span className="text-danger">
                            {errors.contact_no?.message}
                          </span>
                        )}
                      </Form.Group>
                    </Form>
                  </div>

                  <div className="col-md-6">
                    <Form className="field-bottom">
                      <Form.Group controlId="alt_contact_no">
                        <Form.Label className="required">
                          Alternate Mobile Number
                        </Form.Label>

                        <Controller
                          name="alt_contact_no"
                          control={control}
                          render={({ field }) => (
                            <div style={{ position: "relative" }}>
                              <PhoneInput
                                country="in"
                                name="alt_contact_no"
                                value={field?.value}
                                onChange={(value) => field.onChange(value)}

                                disabled={mobileVerify}
                              />
                              {mobileVerify && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "10px",
                                    transform: "translateY(-50%)",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "green",
                                      fontSize: "1.2em",
                                    }}
                                  >
                                    ✔
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        />

                      </Form.Group>
                    </Form>
                  </div>


                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">Country*</Form.Label>


                      <Controller
                        name="country_id" // name of the field
                        {...register("country_id", {
                          required: "Country is required",
                        })}
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            defaultValue={selectedOption}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption?.value); // Update Controller's value
                              getStates(selectedOption?.value);
                              setValue("country_id", selectedOption);
                            }}
                            options={countryOptions}
                            classNamePrefix="buisness"
                            placeholder="Select Country"
                          />
                        )}
                      />
                      {errors.country_id && (
                        <span className="text-danger">
                          {errors.country_id?.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">State*</Form.Label>
                      <Controller
                        name="state_id" // name of the field
                        {...register("state_id", {
                          required: "State is required",
                        })}
                        control={control}
                        render={({ field }) => (

                          <Select
                            {...field}
                            defaultValue={selectedOption}
                            classNamePrefix="buisness"
                            placeholder="Select State"
                            options={stateOptions}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption?.value); // Update Controller's value
                              getCites(selectedOption?.value);
                              setValue("state_id", selectedOption);
                            }}
                          />
                        )}
                      />
                      {errors.state_id && (
                        <span className="text-danger">
                          {errors.state_id?.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">City*</Form.Label>
                      <Controller
                        name="city_id" // name of the field
                        {...register("city_id", {
                          required: "City is required",
                        })}
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.city_id ? "red" : baseStyles,
                              }),
                            }}
                            {...field}
                            classNamePrefix="buisness"
                            options={cityOptions}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption?.value); // Update Controller's value
                              getPincodes(selectedOption?.value);
                              setValue("city_id", selectedOption);
                            }}
                          />
                        )}
                      />
                      {errors.city_id && (
                        <span className="text-danger">
                          {errors.city_id?.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">Pincode*</Form.Label>
                      <Controller
                        name="pincode_id" // name of the field
                        {...register("pincode_id", {
                          required: "Pincode is required",
                        })}
                        rules={{
                          required: "Pincode is required",
                          pattern: {
                            value: /^[0-9]{6}$/, // Only allows exactly 6 digits
                            message: "Pincode must be exactly 6 digits",
                          },
                        }}
                        control={control}
                        render={({ field }) => (
                          <Select
                            classNamePrefix="buisness"
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.pincode_id ? "red" : baseStyles,
                              }),
                            }}
                            {...field}
                                                      options={pincodeOptions}
                            inputProps={{
                              autoComplete: "off", // Prevent browser autofill
                            }}

                          />
                        )}
                      />
                      {errors.pincode_id && (
                        <span className="text-danger">
                          {errors.pincode_id?.message}
                        </span>
                      )}
                    </div>
                  </div>


                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <div className="password-field-holder">
                          <Form.Label className="required">Password*</Form.Label>

                          <Form.Control
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter Password*"
                            className={classNames("", {
                              "is-invalid": errors?.password,
                            })}
                            name="password"
                            {...register("password", {
                              required: "Password is required",
                              minLength: {
                                value: 8,
                                message:
                                  "Password must be at least 8 characters long",
                              },
                              pattern: {
                                value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                message:
                                  "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                              },
                            })}
                            onChange={(e) => setPassword(e.target?.value)}
                          />

                          <ReactPasswordChecklist
                            rules={[
                              "minLength",
                              "specialChar",
                              "number",
                              "capital",
                              "match",
                            ]}
                            minLength={8}
                            value={password}
                            valueAgain={passwordAgain}
                            onChange={(isValid) => { }}
                          />
                          <div className={classNames("eye-icon-holder", {
                            "error-long-message": errors?.password?.message?.length > 12,
                          })}>
                            <FontAwesomeIcon
                              icon={iconOne}
                              className="StepsixeditIcon"
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                            />

                          </div>

                        </div>
                        {errors?.password && (
                          <span className="text text-danger">
                            {errors.password?.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <div className="password-field-holder">
                          <Form.Label className="required">Confirm Password*</Form.Label>

                          <Form.Control
                            type={showPasswordOne ? "text" : "password"}
                            placeholder="Enter Confirm Password*"
                            className={classNames("", {
                              "is-invalid": errors?.re_password,
                            })}
                            name="re_password"
                            {...register("re_password", {
                              required: "Confirm Password is required",
                            })}
                            onChange={(e) => setPasswordAgain(e.target?.value)}
                          />
                          <div className={classNames("confirm-eye-icon-holder", {
                            "error-long-message": errors?.password?.message?.length > 12,
                          })}>
                            <FontAwesomeIcon
                              icon={iconTwo}
                              className="StepsixeditIcon"
                              onClick={() =>
                                togglePasswordVisibility("reenterPassword")
                              }
                            />

                          </div>
                        </div>
                        {errors?.re_password && (
                          <span className="text text-danger">
                            {errors.re_password?.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>






                  <div className="col-md-12">
                    <div className="text-center apply_now_btn">
                      <div className="registerContinueMain">
                        <Button
                          className="tabs-btn"
                          type="submit"
                        // onClick={nextStep}
                        >
                          Save & Next
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stepone;
